import { useEffect, useRef, useState } from 'preact/hooks'

interface CountdownRefreshHookProps {
  pollingIntervalSeconds: number
  onRefresh: () => void
}

export const useCountdownRefresh = ({ pollingIntervalSeconds, onRefresh }: CountdownRefreshHookProps) => {
  const [countdown, setCountdown] = useState(pollingIntervalSeconds)
  const refreshTimerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  const countdownTimerRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined)
  const onRefreshRef = useRef(onRefresh)
  onRefreshRef.current = onRefresh

  const stopCountdown = (): void => {
    if (refreshTimerRef.current) {
      clearTimeout(refreshTimerRef.current)
    }
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current)
    }
  }

  const restartCountdown = (): void => {
    stopCountdown()
    setCountdown(pollingIntervalSeconds)

    refreshTimerRef.current = setTimeout(() => onRefreshRef.current(), pollingIntervalSeconds * 1000)
    countdownTimerRef.current = setInterval(() => {
      setCountdown((prevCountdown) => (prevCountdown > 0 ? prevCountdown - 1 : 0))
    }, 1000)
  }

  useEffect(() => stopCountdown, [])

  return { countdown, stopCountdown, restartCountdown }
}
